import React, { useState } from 'react'
import { IMainStepCreate, IMainStepData } from '../../../../../models/freshman/mainStep'
import FloatingLabelTextInput from '../../../../../common-components/floatingtextinput'
import Joi from 'joi'
import { alertConstants, getAlertData } from '../../../../../helper/sweet-alert'
import { validateFields } from '../../../../../helper/joi-validation'
import { connect } from 'react-redux'
import { createMainStep } from '../../../../../action/freshman/mainstepActionCreator'
import SweetAlert from 'react-bootstrap-sweetalert'
import LoaderSpinner from '../../../../../common-components/loader'

const MainStepCreate = (props: IMainStepCreate) => {
    const { setShowCreate, getAllMainSteps, createMainStep } = props

    const initialData: IMainStepData = {
        id: 0,
        name: "",
        description: "",
        isActive: true,
    };

    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState<any>(undefined);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<any>("success");
    const [alertTitle, setAlertTitle] = useState<string>("Default");
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);

    const onChange = (
        event:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        errors && delete errors[event.target.name];

        const _data = { ...data, [event.target.name]: event.target.value };
        setData(_data);
    };

    const schema = Joi.object().keys({
        name: Joi.string().required().label("Name is required"),
    });

    const onSave = async () => {
        const cleanedData = {
            ...data,
            name: data.name.trim().replace(/\s+/g, ' '),
        };
        const validationErrors = validateFields(cleanedData, schema);
        if (validationErrors === undefined) {
            setLoading(true)
            setIsDisabled(true)
            try {
                await createMainStep(cleanedData, setAlert);
            } finally {
                setLoading(false)
                setIsDisabled(false)
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // setting sweet alert dynamically
    const setAlert = (type: string) => {
        let alertData = getAlertData(type);
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
        }
    };

    // executed on clicking 'OK' in sweet alert.
    const onConfirm = () => {
        if (alertType === alertConstants.error) {
            setShowAlert(false);
        } else {
            getAllMainSteps(true);
            setShowCreate(false);
        }
    };

    //setting warning alert on cancel
    const onCancel = async () => {
        setShowAlertCancel(true);
        setAlert(alertConstants.cancelCheck);
    };

    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="addnewbuttonsLabel">Add Main Task</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowCreate(false)}></button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-lg-12 form-group">
                        <FloatingLabelTextInput
                            label={"Name "}
                            onChange={onChange}
                            isMandatory={true}
                            value={data.name}
                            name={"name"}
                            maxLength={50}
                        />
                        {errors?.name && <div className="text-danger">{errors.name}</div>}
                    </div>
                    <div className="col-lg-12 form-group">
                        <label className="profile_details_text">Description</label>
                        <textarea
                            name="description"
                            value={data.description}
                            onChange={onChange}
                            maxLength={1000}
                            required
                        >
                            {" "}
                        </textarea>
                        {errors?.description && <div className="text-danger">{errors.description}</div>}
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onSave}
                        disabled={isDisabled}>
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowCreate(false)}>
                        Close
                    </button>
                </div>
            </div>
            <SweetAlert
                show={showAlert}
                success={false}
                type={alertType}
                title={alertTitle}
                onConfirm={() => onConfirm()}
                showCancel={showAlertCancel}
                onCancel={() => {
                    setShowAlert(false);
                    setShowAlertCancel(false);
                }}
                cancelBtnText={"No"}
                confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
            ></SweetAlert>
            {loading && (<LoaderSpinner />)}
        </>
    )
}

const mapDispatchToProps = {
    createMainStep: (data: any, callBack: Function) => createMainStep(data, callBack),
};

function mapStateToProps(state: any) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainStepCreate);